<template>

        <ion-item>
          <ion-grid>
            <ion-row>
              <div v-for="item in buttons" v-bind:key="item.index">
                <ion-col>
                  <ion-button  :fill="item.fill" :color="item.color" @click="onClickButton(item)">{{ item.label }}</ion-button>
                </ion-col>
              </div>
            </ion-row>
            <ion-row>
              <div v-for="item in shapes" v-bind:key="item.index + 10">
                <ion-col>
                  <ion-button :fill="item.fill"  @click="onClickShape(item)">{{ item.label }}</ion-button>
                </ion-col>
              </div>
            </ion-row>
          </ion-grid>
        </ion-item>
  </template>
  
  <script setup>
  
  import { IonCheckbox, IonIcon, IonGrid,IonRow,IonCol,IonButton,IonButtons,IonItem,IonInput,IonPage, IonContent, modalController } from '@ionic/vue';

  import { ref , watch } from 'vue'
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { computed } from "@vue/reactivity"

  const props = defineProps({
    color : {
      type : String,
      default : "yellow"
    },
    action : {
      type : String,
      default : "fill"
    }
  })

  const emit = defineEmits(['learn-markup-change'])

  const buttons = ref([
    { index : 0, color : "primary", label : "Blue", fill : "outline"},
    { index : 1, color : "warning", label : "Yellow", fill : "outline"},
    { index : 2, color : "success", label : "Green", fill : "outline"},
    { index : 3, color : "danger", label : "Red", fill : "outline"},
  ])

  const shapes = ref([
    { index : 0, label : "Fill", fill : "outline", action : "fill"},
    { index : 1, label : "Border", fill : "outline", action : "border"},
    { index : 2, label : "Arrow", fill : "outline", action : "arrow"},
    { index : 3, label : "Clear", fill : "outline", action : "clear"},
  ])

  // set the initial selected values
  for (var i=0; i < buttons.value.length; i++)
    if (props.color == buttons.value[i].label.toLowerCase()) {
      buttons.value[i].fill = "solid"
      break
    }

  for (var i=0; i < shapes.value.length; i++)
    if (props.action == shapes.value[i].action) {
      shapes.value[i].fill = "solid"
      break
    }
   
  function onClickButton(button) {
    if (button.fill == "solid")
      return
    for (var i=0; i < buttons.value.length; i++)
      buttons.value[i].fill = "outline"
    button.fill = "solid"
    emit('learn-markup-change','color',button.label.toLowerCase())
  }
  
  function onClickShape(shape) {
    if (shape.fill == "solid")
      return

    // if clear, just emit but don't switch the highlight
    if (shape.action == "clear") {
      emit('learn-markup-change','action','clear')
      return
    }
    
    for (var i=0; i < shapes.value.length; i++)
      shapes.value[i].fill = "outline"
    shape.fill = "solid"
    emit('learn-markup-change','action',shape.action)
   }

  </script>
  
  <style scoped>
  
  </style>
  